/**
 * CONSENT-01 (868kmgf87) — el texto vigente que hay que poner delante.
 *
 * El idioma va en la clave de consulta a propósito: cambiarlo tiene que
 * refrescar el cuerpo, porque la versión y la rendición que se muestran son
 * las que luego se registran. Es el mismo criterio que DISCLAIMER-01.
 */

import { useQuery } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import { CONSENT_ENDPOINT, fetchConsentText } from '../api/consent.api';
import type { ConsentText, ConsentType } from '../types/consent.types';

export function useConsentText(consentType: ConsentType) {
  const intl = useIntl();
  const language = intl.locale;

  return useQuery<ConsentText>({
    queryKey: [CONSENT_ENDPOINT, consentType, 'text', language],
    queryFn: () => fetchConsentText(consentType, language),
  });
}
